// extracted by mini-css-extract-plugin
module.exports = {"content":"IdentityPage_content__zUHHn","desktopTopbar":"IdentityPage_desktopTopbar__AHIaY","mobileTopbar":"IdentityPage_mobileTopbar__35MhF","title":"IdentityPage_title__tTFwC"};